import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import Breadcrumbs from "../../../component/Breadcrumbs";
import { MinimizeIcon } from "../../../redux/action/Login";
import { CustomDiv } from "../../chat-bot/style";
import { HandleSkeletion } from "../../../utils/constants";

export default function WhatNew() {
  const updatedVersion = process.env.REACT_APP_WHAT_NEW_URL;
  const dispatch = useDispatch();

  const breadCrumbData = [
    {
      title: "About",
      navigate: "/about",
    },
    {
      title: "What’s New ?",
      active: true,
    },
  ];

  const [data, setData] = useState({
    content: "",
    loading: false,
  });

  useEffect(() => {
    setData((prev) => ({
      ...prev,
      loading: true,
    }));

    fetch(updatedVersion)
      .then((res) => {
        return res.text();
      })
      .then((html) =>
        setData({
          content: html,
          loading: false,
        })
      )
      .catch((err) =>
        setData({
          content: "",
          loading: false,
        })
      );
  }, [updatedVersion]);

  useEffect(() => {
    dispatch(MinimizeIcon(true, false));
  }, []);

  return (
    <CustomDiv
      margin={"1rem 1rem 1rem 1.5rem"}
      padding={"1rem"}
      borderRadius={"10px"}
      background="#fff"
      border={"1px solid rgba(0, 0, 0, 0.12)"}
    >
      <Breadcrumbs breadCrumbData={breadCrumbData} />

      {data.loading ? (
        <HandleSkeletion width={"100%"} height={"150px"} />
      ) : (
        <div
          className="what-news-markdown"
          dangerouslySetInnerHTML={{ __html: data.content }}
        />
      )}
    </CustomDiv>
  );
}
